import useGa from 'Client/hooks/useGa';
import { WishListTrackingAction } from 'Client/redux/products/types';
import { TrackLooksActions } from 'Common/ga/types';

export const useLooksTracking = () => {
    const gaTracking = useGa();

    return {
        LLP: {
            track: (action: TrackLooksActions, label: string) => {
                gaTracking.trackLLP({ action, label });
            },
        },
        LDP: {
            track: (action: TrackLooksActions, label: string) => {
                gaTracking.trackLDP({ action, label });
            },
            trackWishlist: (action: WishListTrackingAction, label: string) => {
                gaTracking.trackWishListHeartClick(action, label);
            },
        },
    };
};
